import { render, staticRenderFns } from "./c-Kelas.vue?vue&type=template&id=e01e358a&scoped=true&"
import script from "./c-Kelas.vue?vue&type=script&lang=js&"
export * from "./c-Kelas.vue?vue&type=script&lang=js&"
import style0 from "./c-Kelas.vue?vue&type=style&index=0&id=e01e358a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01e358a",
  null
  
)

export default component.exports